import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedAdmin = ({ children, isAdmin, isAuthLoading }) => {
  if (isAuthLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default ProtectedAdmin;
